import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { getLocale } from "@pb/utils/locale";
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import { default as request } from "@pb/utils/request";
import { default as getCookie } from "@pb/utils/getCookie";
import { default as consoleEvents } from "@pb/utils/consoleEvents";
import { default as getUserFeatures } from "@pb/utils/getUserFeatures";
import { isMobileDevice } from "@pb/utils/touchpoint";
import cn from 'classnames';
import Label from "../Label";
import { IconButton } from "../../ui/CTA";
import Button from "../../ui/CTA/Button";
import { AppStoreIcon, GooglePlayIcon } from "../../ui/Icon";
import Modal from "../../ui/Modal";
import BodyText from "../../ui/Typography/texts/BodyText";
import HeadingMedium from "../../ui/Typography/titles/HeadingMedium";
import HeadingSmall from "../../ui/Typography/titles/HeadingSmall";
import Selector from './components/Selector';
import { NiBConstant } from './helpers/constants';
import { getVariation, trackOptimizelyVanillaEvent } from './helpers/optimizely';
import { trackNiBCompleteSuccess, trackNibShowBecomeMember, trackAppStoreClick, trackOnNibInitiate, } from './helpers/tracking';
import styles from './LagacyNotifyIfBack.module.scss';
export const getCookieInfo = () => {
    const userCookie = getCookie('userCookie');
    if (userCookie) {
        const dataInJSON = JSON.parse(userCookie);
        const userEmail = dataInJSON ? dataInJSON.hybris_uuid : '';
        const bpid = dataInJSON ? dataInJSON.bpid : '';
        return { userEmail, bpid };
    }
    return { userEmail: '', bpid: '' };
};
export const onSubmitRequest = (reqData) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const apiUrl = ((_b = (_a = hm === null || hm === void 0 ? void 0 : hm.options) === null || _a === void 0 ? void 0 : _a.notifyIfBack) === null || _b === void 0 ? void 0 : _b.apiUrl) || '';
    try {
        const result = yield request.post(apiUrl, { data: reqData });
        return result.data;
    }
    catch (error) {
        return error;
    }
});
const updatedActivatedOosItems = (code, array) => array &&
    array.map((a) => {
        const modifiedItem = a.value === code ? Object.assign(Object.assign({}, a), { isActive: true }) : Object.assign(Object.assign({}, a), { isActive: false });
        return modifiedItem;
    });
const activatedOosItems = (array) => array === null || array === void 0 ? void 0 : array.map((a) => {
    const modifiedItem = a.isActive !== true ? Object.assign(Object.assign({}, a), { isActive: false }) : a;
    return modifiedItem;
});
const findPreActivatedOosItems = (array) => {
    const findActivatedItem = array && array.find((a) => a.isActive === true && a.value !== undefined);
    return (findActivatedItem === null || findActivatedItem === void 0 ? void 0 : findActivatedItem.value) || undefined;
};
const NotifyIfBack = ({ oosItems, triggerOpen, toggleModal, notifyIfBack = 'none', handleShowOverlay, isCalledFromFavorite, }) => {
    var _a, _b;
    const [isOpen, setIsOpen] = useState(false);
    const [isSignedIn, setIsSignedIn] = useState(null);
    const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(null);
    const [selectedVariant, setSelectedVariant] = useState('');
    const [cookieData, setCookieData] = useState();
    const [items, setItems] = useState(undefined);
    const [isDownloadAppBannerVisibile, setIsDownloadAppBannerVisibile] = useState(false);
    const [bannerContent, setBannerContent] = useState();
    const userFeatures = getUserFeatures();
    const isMobile = isMobileDevice();
    let heading;
    let info;
    let text;
    let boldText;
    let button;
    let onClickButton;
    let disabledButton = false;
    const closeModal = () => {
        setIsOpen(false);
        if (toggleModal)
            toggleModal();
    };
    const signInJourney = () => {
        var _a, _b, _c;
        if (notifyIfBack === 'pb') {
            closeModal();
            appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish('SHOW_LIGHTBOX', { template: 'sign-in', classes: 'nib' });
            if (handleShowOverlay)
                handleShowOverlay();
        }
        else if ((_c = (_b = (_a = hm === null || hm === void 0 ? void 0 : hm.Remodal) === null || _a === void 0 ? void 0 : _a.Utils) === null || _b === void 0 ? void 0 : _b.Actions) === null || _c === void 0 ? void 0 : _c.showModal) {
            hm.Remodal.Utils.Actions.showModal('signin');
        }
        else {
            consoleEvents.error('hm.Remodal.Utils.Actions.showModal not found');
        }
    };
    const locale = notifyIfBack === 'hm' ? (_b = (_a = hm === null || hm === void 0 ? void 0 : hm.options) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.locale : getLocale();
    const userEmail = cookieData === null || cookieData === void 0 ? void 0 : cookieData.userEmail;
    const selectorText = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.selectSize" });
    const submitRequest = () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield onSubmitRequest({
            bpid: cookieData === null || cookieData === void 0 ? void 0 : cookieData.bpid,
            email: cookieData === null || cookieData === void 0 ? void 0 : cookieData.userEmail,
            locale,
            variant: selectedVariant,
        });
        const isNibFormSubmittedSuccessfully = !!(result === null || result === void 0 ? void 0 : result.success);
        setIsSubmitSuccessful(isNibFormSubmittedSuccessfully);
        if (isNibFormSubmittedSuccessfully) {
            trackNiBCompleteSuccess({
                product_article_id: selectedVariant.slice(0, -3),
                product_size_code: selectedVariant.slice(-3),
            });
        }
    });
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (isOpen) {
            trackOnNibInitiate({
                product_article_id: ((_b = (_a = window === null || window === void 0 ? void 0 : window.hm) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.getArticleId()) || '',
                product_size_code: ((_d = (_c = window === null || window === void 0 ? void 0 : window.hm) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.getSelectedSize()) || '',
            }, isCalledFromFavorite);
            if (!((_e = getCookieInfo()) === null || _e === void 0 ? void 0 : _e.userEmail)) {
                trackNibShowBecomeMember({
                    product_article_id: ((_g = (_f = window === null || window === void 0 ? void 0 : window.hm) === null || _f === void 0 ? void 0 : _f.product) === null || _g === void 0 ? void 0 : _g.getArticleId()) || '',
                    product_size_code: ((_j = (_h = window === null || window === void 0 ? void 0 : window.hm) === null || _h === void 0 ? void 0 : _h.product) === null || _j === void 0 ? void 0 : _j.getSelectedSize()) || '',
                });
            }
        }
    }, [isOpen]);
    useEffect(() => {
        setItems(activatedOosItems(oosItems));
        setIsSubmitSuccessful(null);
        const cookieInfo = getCookieInfo();
        setCookieData(cookieInfo);
        if (triggerOpen) {
            setIsOpen(triggerOpen);
        }
    }, [triggerOpen]);
    useEffect(() => {
        const activeItemValue = items && findPreActivatedOosItems(items);
        if (activeItemValue) {
            setSelectedVariant(activeItemValue);
        }
    }, [items]);
    useEffect(() => {
        setIsSignedIn(!!(cookieData === null || cookieData === void 0 ? void 0 : cookieData.userEmail));
    }, [cookieData]);
    useEffect(() => {
        if (isSubmitSuccessful) {
            getVariation([NiBConstant.VARIABLE_BANNER_OBJECT])
                .then((data) => {
                if (data === null || data === void 0 ? void 0 : data.flag) {
                    setIsDownloadAppBannerVisibile(data.flag);
                    setBannerContent(data.download_app_content);
                    trackOptimizelyVanillaEvent(NiBConstant.VIEW_DOWNLOAD_APP_COMPONENT);
                }
            })
                .catch((e) => {
                consoleEvents.error('Error in Favorite and Cart Items On Sale component', e);
            });
        }
    }, [isSubmitSuccessful]);
    if (!isSignedIn) {
        heading = React.createElement(Label, { copyKey: "notifyIfBack.modal.login.heading" });
        info = React.createElement(Label, { copyKey: "notifyIfBack.modal.login.info" });
        text = React.createElement(Label, { copyKey: "notifyIfBack.modal.login.text" });
        button = React.createElement(Label, { copyKey: "notifyIfBack.modal.login.button" });
        onClickButton = signInJourney;
    }
    else {
        switch (isSubmitSuccessful) {
            case false:
                heading = React.createElement(Label, { copyKey: "notifyIfBack.modal.error.heading" });
                info = React.createElement(Label, { copyKey: "notifyIfBack.modal.error.info" });
                button = React.createElement(Label, { copyKey: "notifyIfBack.modal.error.button" });
                onClickButton = submitRequest;
                break;
            case true:
                heading = React.createElement(Label, { copyKey: "notifyIfBack.modal.success.heading" });
                info = React.createElement(Label, { copyKey: "nib.email.when.back", replacements: userEmail });
                button = React.createElement(Label, { copyKey: "notifyIfBack.modal.success.button" });
                onClickButton = closeModal;
                break;
            default:
                heading = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.heading" });
                info = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.info" });
                boldText = React.createElement(Label, { copyKey: "notifyIfBack.modal.select.notify" });
                text = userEmail;
                button = React.createElement(Label, { copyKey: "notifyIfBack.notifyMeList" });
                onClickButton = submitRequest;
                disabledButton = selectedVariant === '';
        }
    }
    const updateSelectedValue = (code) => {
        setSelectedVariant(code);
        setItems(updatedActivatedOosItems(code, items));
    };
    const trackStoreClick = (appStoreName) => {
        const tags = {
            bpid: userFeatures.bpid,
        };
        if (appStoreName === 'App Store') {
            trackOptimizelyVanillaEvent(NiBConstant.EVENTS_CLICK_APP_STORE, tags);
        }
        else {
            trackOptimizelyVanillaEvent(NiBConstant.EVENTS_CLICK_GOOGLE_PLAY, tags);
        }
        trackAppStoreClick(appStoreName);
    };
    const title = getLabelFromStorage('notifyIfBack.notifyMeList');
    const close = getLabelFromStorage('general.close');
    return (React.createElement(Modal, { title: title, closeButtonText: close, isOpen: isOpen, isDownloadAppBannerAccessible: true, toggleModal: closeModal, focusTrapWrapperClassname: styles.modalWrapper, disableRemoveScroll: isMobile, hasNoIsolation: isMobile },
        heading && (React.createElement(HeadingSmall, { Tag: "h3", className: cn(styles.centerAlignText, styles.innerHeading) }, heading)),
        info && (React.createElement(BodyText, { className: cn(styles.centerAlignText, styles.infoText, !heading && styles.infoTextTop) }, info)),
        isSignedIn && isSubmitSuccessful === null && (React.createElement(Selector, { label: selectorText, items: items, onSizePick: (code) => updateSelectedValue(code) })),
        boldText && (React.createElement(BodyText, { className: cn(styles.centerAlignText, styles.notifyText) },
            boldText,
            " ",
            text)),
        button && (React.createElement(Button, { type: "button", onClick: onClickButton, className: styles.centerAlignButton, disabled: disabledButton }, button)),
        isSubmitSuccessful && isDownloadAppBannerVisibile && (React.createElement("div", { className: styles.appStoreContainer },
            bannerContent && (React.createElement(React.Fragment, null,
                React.createElement(HeadingMedium, null, bannerContent[locale].banner_title),
                React.createElement(BodyText, null, bannerContent[locale].banner_description))),
            React.createElement(IconButton, { Tag: "a", className: styles.appStoreIcon, target: "_blank", rel: "noreferrer nofollow", href: "https://apps.apple.com/app/h-m/id834465911", onClick: () => trackStoreClick('App Store'), iconElement: React.createElement(AppStoreIcon, { className: styles.appStoreLink }) }, "App Store"),
            React.createElement(IconButton, { Tag: "a", target: "_blank", rel: "noreferrer nofollow", className: styles.appStoreIcon, href: "https://play.google.com/store/apps/details?id=com.hm.goe", onClick: () => trackStoreClick('Google Play'), iconElement: React.createElement(GooglePlayIcon, { className: styles.appStoreLink }) }, "Google Play")))));
};
export default NotifyIfBack;
//# sourceMappingURL=LegacyNotifyIfBack.js.map